import { TRACKING_EVENT_NAMES } from './constants'
import { useTrack } from './useTrack'

export const useTrackTooltipClicked = () => {
  const track = useTrack()

  const trackTooltipClicked = ({ ...eventProperties }) => track({
    name: TRACKING_EVENT_NAMES.TOOLTIP_CLICKED,
    properties: eventProperties,
  })

  return trackTooltipClicked
}
